//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";
import GameRuleView from "./game_rule_view";
import AppData from "../../../public/const/app_data";

@ccclass
@moduleInit("GameRule")
export default class GameRule extends ModuleBase<GameRuleView, null> {
    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/table/game_rule";
        this.viewType = GameRuleView;
        this.needAnim = false
    }

    

    onShow(intentData) {
        this.view.tweenTo("Start", false)
        this.view.initItems()
    }

    protected onButtonClickName(name: string) {
        let self = this
        switch (name) {
            case "MoreMaskBtn":
                this.view.tweenTo("Start", true)
                self.scheduleOnce(function () {
                    self.hide()
                }, 0.2)
                break
            default:
                break
        }
    }
    
    onHide() {
        super.onHide()
    }

    onDisable() {
        this.unscheduleAllCallbacks()
    }

    onDestroy() {
        this.unscheduleAllCallbacks()
    }
}